import React from "react"; 

import { retailUser } from "./Forms.js"

import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { eachDayOfInterval } from "date-fns";

function combineStrings(strings) {
  let text = "Excluded Feedback: "

  for (let i=0; i < strings.length; i++) {
    if (i > 0 && i === strings.length-1) {
      text += " and "
    }
    else if (i > 0) {
      text += ", "
    }
    text += `"${strings[i]}"`
  }

  return text
}

function joiner(feedbackTypesMessage, feedbackQuestionsMessage) {
  return feedbackTypesMessage === undefined || feedbackQuestionsMessage === undefined ? "" : "and"
}

function plural(feedbackQuestionsMessage, feedback) {
  const quantity = feedbackQuestionsMessage === "" ? feedback.feedback_types.length : feedback.feedback_questions.length

  return quantity > 1 ? "have" : "has"
}

function feedbackMessage(feedback, type) {
  if (feedback.length === 0) {
    return
  }

  const plural = feedback.length > 1 ? "s" : ""

  return <span style={{cursor: "context-menu"}} title={combineStrings(feedback)}>{feedback.length} Feedback {type}{plural}</span>
}

export function showExcludedFeedback(feedback) {
  if (Object.keys(feedback).length === 0) {
    return
  }

  if (feedback.feedback_types.length === 0 && feedback.feedback_questions.length === 0) {
    return
  }

  const feedbackTypesMessage = feedbackMessage(feedback.feedback_types, "Type")
  const feedbackQuestionsMessage = feedbackMessage(feedback.feedback_questions, "Question")

  return (
    <div>
      {feedbackTypesMessage} {joiner(feedbackTypesMessage, feedbackQuestionsMessage)} {feedbackQuestionsMessage} {plural(feedbackQuestionsMessage, feedback)} been excluded from Overview.
    </div>
  )
}

export function debounce(func, timeout = 500) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function optionalParam(optional_param, value) {
  if (value.length > 0 || value === true) {
    return `${optional_param}=${value}`
  }
  else {
    return ""
  }
}

export function buildParams (...optionalParams) {
  return `${optionalParams.filter(param => param !== "").join("&")}`
}

export function formatNewLines(text) {
  var key = 0
  return text.split('\n').map(line => <p key={key += 1}>{line}</p>)
}

export function renderScoreComment(positive_score) {
  // If you don't have anything nice to say, don't say anything at all.
  if (positive_score === 0) {
    return ""
  }

  let pluralize = positive_score > 1 ? "s" : "";

  return <div className="score-comments small-top-padding"><em>{positive_score} user{pluralize} found this helpful.</em></div>
}

export function renderAlternateName(person) {
  if (person.alternate_name !== null && person.alternate_name !== "" && person.alternate_name !== undefined) {
    return `(${person.alternate_name})`
  }
}

export function renderFullName(person) {
  if (person.display_name) {
    return `${person.display_name} ${person.last_name}`
  }

  let alternate_name = renderAlternateName(person)
  if (alternate_name) {
    return `${person.first_name} ${alternate_name} ${person.last_name}`
  }

  return `${person.first_name} ${person.last_name}`
}

export function convertToSlug(name) {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, ''); // Remove any non-alphanumeric characters except hyphens
}

export function formatDate(date, minus, separator = "-", order = "") {
  if (minus === undefined) {
    minus = 0
  }

  date.setDate(date.getDate() - minus);
  let day = ("0" + date.getDate()).slice(-2)
  let month = ("0" + (date.getMonth() + 1)).slice(-2)
  let year = date.getFullYear()

  if (order === "dayFirst") {
    return `${day}${separator}${month}${separator}${year}`
  }

  return `${year}${separator}${month}${separator}${day}`
}

export function convertTime(hour, includeSuffix = true) {
  let suffix
  if (hour < 12) {
    suffix = "am"
  }
  else if (hour > 11) {
    if (hour !== 12) {
      hour = hour - 12
    }
    suffix = "pm"
  }

  return includeSuffix === true ? `${hour}${suffix}` : hour
}

export function datify(dateString) {
  if (dateString === "N/A") {
    return (new Date(1970))
  }
  else {
    let [dateInfo, timeInfo] = dateString.split(" ")

    // Swap out <Time Removed> for midnight
    if (timeInfo === "<Time") {
      timeInfo = "00:00"
    }

    // Convert date to yyyy/mm/dd
    let [day, month, year] = dateInfo.split("/")
    return new Date(`${year}/${month}/${day} ${convertToTwentyFourHourTime(timeInfo)}`)
  }
}

export function convertToTwentyFourHourTime(timeString) {
  if (timeString === undefined) {
    return
  }

  let [hour, minutes] = timeString.split(":");

  if (timeString.includes("m")) {
    let amOrPm = timeString.slice(-2);

    if (amOrPm === "am") {
      if (hour === "12") {
        hour = "0"
      }
    }
    else {
      if (hour !== "12") {
        hour = parseInt(hour) + 12
      }
    }
  }
  hour = ("00" + hour).slice(-2)

  return `${hour}:${minutes.slice(0, 2)}`
}

export function getContrastYIQ(hexcolor) {
    if (!hexcolor) {
      return "black"
    }

    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
  }

  export function mixWithWhite(color) {
    color = color.slice(1);

    var num = parseInt(color,16);

    // This makes an average between the original color and white (rgb 255)
    var r = Math.round(((num >> 16) + 255) / 2);
    var b = Math.round((((num >> 8) & 0x00FF) + 255) / 2);
    var g = Math.round(((num & 0x0000FF) + 255) / 2);

    return "#" + (g | (b << 8) | (r << 16)).toString(16);
  }

export function futureEndDayOfWeek(start_day_of_week, start_time, end_time) {
  let end_day_of_week = start_day_of_week

  if (start_time > end_time) {
    end_day_of_week = parseInt(start_day_of_week) + 1
  }

  return end_day_of_week
}

export function futureEndDate(start_date, start_time, end_time) {
  let endDate = new Date(start_date);

  if (start_time > end_time) {
    endDate.setDate(endDate.getDate() + 1);
  }

  return endDate;
}

export function arrayParamBuilder(resourceName, attributeName, ids) {
  // Convert array of integers into GET request compatible params
  // Not necessary for stringified JSON

  if (ids === "all") {
    return ""
  }

  let param = ""
  for (let id of ids) {
    if (resourceName === null) {
      // i.e. `&tag_ids[]=1&tag_ids[]=2`
      param += `&${attributeName}[]=${id}`
    }
    else {
      // i.e. `&people[custom_attribute_ids][]=1&people[custom_attribute_ids][]=2`
      param += `&${resourceName}[${attributeName}][]=${id}`
    }
  }

  return param
}

export function listWithGrammar(array) {
  if (array.length === 0) {
    return ""
  }

  if (array.length === 1) {
    return array[0]
  }

  let comma_separated_array = array.slice(0, -1).join(", ")

  return `${comma_separated_array} and ${array[array.length - 1]}`
}

export function renderSortColumn(title, attribute){
  if (this.props.sort === attribute) {
    let directionArrow = "▲"
    if (this.props.direction === "desc") {
      directionArrow = "▼"
    }
    return (
      <div className="th sortable sorted" onClick={() => this.props.handleSortChange(attribute)}>
        <strong>{title}</strong>
        <div><strong>{directionArrow}</strong></div>
      </div>
    )
  }
  else {
    return (
      <div className="th sortable" onClick={() => this.props.handleSortChange(attribute)}>
        {title}
      </div>
    )
  }
}

export function arraysEqual(a, b) {
  if (a === b) {
    return true
  }
  if (a == null || b == null) {
    return false
  }
  if (a.length !== b.length) {
    return false
  }

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) {
      return false
    }
  }

  return true;
}

export function hideResidentsCheck() {
  return localStorage.getItem("type_of_organisation") === "Retail"
}

export function duration(start, end) {
  if (typeof start === "string") {
    start = new Date(start)
  }

  if (typeof end === "string") {
    end = new Date(end)
  }

  const differenceInMilliseconds = end - start;
  return differenceInMilliseconds / (1000 * 60)
}

export function onlineDeviceColor(device) {
  switch(device.online_device_color) {
    case "green":
      return "#22ee80"
    case "yellow":
      return "#eee622"
    case "orange":
      return "#f29e32"
    case "red":
      return "#ce5252"
    default:
      return "#fff"
  }
}

export function renderPhotoStatus(photo_status) {
  if (photo_status === "not configured") {
    return <span title="The profiles on this device are not configured to take photos.">Profile not configured</span>
  }

  if (photo_status === "no devices") {
    return <span title="No physical devices are associated with this device.">Device not set up</span>
  }

  if (photo_status === "ok") {
    return <FontAwesomeIcon icon={faCheckCircle} className="green-text" title="None of the physical devices contacted recently appear to have photo taking issues at the moment." />
  }

  let title = "One or more of the physical devices contacted recently have issues taking photos: "

  if (photo_status.includes("too_many_photos")) {
    title += "too many photos are stored locally"
  }

  if (photo_status.includes("too_many_photos") && photo_status.includes("rejected_photos")) {
    title += " and "
  }

  if (photo_status.includes("rejected_photos"))  {
    title += "our app does not have permission to use the camera"
  }

  title += "."

  return <FontAwesomeIcon icon={faTimes} className="red-text" title={title} />
}

export function renderPlannedEventOrAppointment(appointment = retailUser()) {
  if (appointment) {
    return "Appointment"
  }

  return "Planned Event"
}

export function renderPlannedEventURL(appointment = retailUser()) {
  if (appointment) {
    return "appointments"
  }

  return "planned-events"
}

export function holidaysDaysUsed(holidays) {
  let total_holidays = 0

  holidays.forEach(holiday => {
    const days = eachDayOfInterval({ start: new Date(holiday.start_date), end: new Date(holiday.end_date) });
    total_holidays +=  days.length

    if (holiday.half_day_work_at_start) total_holidays -= 0.5;
    if (holiday.half_day_work_at_end) total_holidays -= 0.5;
  });

  return total_holidays
}

export function truncate(string, length) {
  if (string.length > length) {
    return string.slice(0, length) + "..."
  }
  else {
    return string
  }
}

export const docExtensionsArray = ["doc", "docm", "docx", "dot", "dotx", "txt"];
export const videoExtensionsArray = ["mp4", "mpg", "mpeg", "mov", "avi"];
export const pdfExtensionsArray = ["pdf"];
export const imageExtensionsArray = ["png", "jpg", "jpeg", "gif", "bmp", "jfif", "tif", "webp"];
export const csvExtensionsarray = ["csv", "xls", "xlsm", "xlsx"];

export const nonImageExtensionsArray = docExtensionsArray.concat(videoExtensionsArray).concat(pdfExtensionsArray).concat(csvExtensionsarray);

export const TYPE_OF_PEOPLE = ["visitor", "resident", "staff", "contractor", "industry professional", "agency", "volunteer", "other"]
export const BASE_ONLY_TYPE_OF_PEOPLE = ["resident", "staff", "contractor", "industry professional", "agency", "volunteer", "other"]
export const STAFF_TYPE_OF_PEOPLE = ["staff", "contractor", "agency", "volunteer"]
